import { addDays, startOfWeek } from 'date-fns';
import { format } from '@bridebook/web/lib/i18n/utils/get-date-fns-format';
import { Info } from 'luxon';
import { defaultLocale } from '@bridebook/toolbox/src/gazetteer';

const weekdayFormat = {
  full: 'EEEE', // Monday, Tuesday, ..., Sunday
  medium: 'EEE', // Mon, Tue, Wed, ..., Sun
  short: 'EEEEEE', // Mo, Tu, We, Th, Fr, Su, Sa
};

/**
 * Generates an array of names for all days of week
 */
export const getLocalisedWeekdays = (
  length: keyof typeof weekdayFormat = 'full',
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 1,
) => {
  const firstDayOfWeek = startOfWeek(new Date(), { weekStartsOn });

  return Array.from(Array(7)).map((_, i) =>
    format(addDays(firstDayOfWeek, i), weekdayFormat[length]),
  );
};

/**
 * Generates an array of names for all months
 */
export const getLocalisedMonths = (
  locale: string = defaultLocale,
  length: 'long' | 'short' = 'long',
) => Info.months(length, { locale });
